/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 14:33:56
 * @LastEditors: linxi
 * @LastEditTime: 2024-09-23 16:53:12
 */
import { SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Space,
  Table,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { EditableList } from '../../compnents/list/EditableList'
import { ThemeContext } from '../../theme/ThemeContext'
import { getPatientLabels } from '../patient/list/patientListSlice'
import { AddMembersModal } from './addMembersModal'
import { TopUpModal } from './topUpModal'
import { TopUpRecordModal } from './topUpRecordModal'
import { Columns } from './columns'
import styles from './MembersManagementPage.module.css'
import { useHistory } from 'react-router-dom'
import {
  getAddMembers,
  getMembersPage,
  getMembersTopUp,
} from './MembersManagementPageSlice'
import { Query } from './Query'
import { loadavg } from 'node:os'
import { BindMembersModal } from './bindMemberModal'
interface MembersManagementPageProps {
  state?: string
  isMenu?: boolean
}

export const MembersManagementPage = ({
  state,
  isMenu = false,
}: MembersManagementPageProps): ReactElement => {
  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState({ current: 1, size: 10, startTime: '', endTime: '' })

  const [page, setPage] = useState({ items: [], total: 0, balanceMoneySUM: 0 })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [addMembersVisible, setAddMembersVisible] = useState(false) // 新增会员弹窗

  // 会员卡绑定弹窗
  const [bindMembersVisible, setBindMembersVisible] = useState(false) // 新增会员弹窗 

  const [addBtnType, setAddBtnType] = useState(false) // 新增会员弹窗

  const [topUpModalVisible, setTopUpModalVisible] = useState(false) // 充值 or 退款 弹窗

  const [membersId, setMembersId] = useState(0) // 会员 ID

  const [editId, setEditId] = useState<any>() //编辑id

  const [topUpRecordModalVisible, setTopUpRecordModalVisible] = useState(false) // 充值记录弹窗

  const [modalText, setModalText] = useState(0) // 充值 or 退款 弹窗标题

  const getTablePage = () => {
    setPageLoading(true)
    dispatch(getMembersPage({
      ...params,
      startTime: params?.startTime ? params?.startTime : '',
      endTime: params?.endTime ? params?.endTime : '',
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          balanceMoneySUM: res?.balanceMoneySUM,
          items: res?.memberPageVO?.records,
          total: res?.memberPageVO?.total,
        })
      })
      .finally(() => setPageLoading(false))
  }


  useEffect(() => {
    !isMenu &&
      sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  useEffect(() => {
    params.current && getTablePage()
  }, [params])


  return (
    <Col className={state ? styles.wrap : styles.wraps}>
      <Query
        loading={pageLoading}
        onValueChange={(v) => {
          setParams({
            ...params,
            ...v,
            current: 1,
          })
        }}
        addMember={() => {
          setAddMembersVisible(true)
          setEditId('')
        }}
        // 会员卡管理
        manageMember={() => {
          history.push({
            pathname: '/member/membersCardManagement',
            state: {
              isMenu,
            },
          })
        }}
        // 会员卡绑定
        bindMember={() => {
          setBindMembersVisible(true)
        }}
      />
      <EditableList
        className={styles.patientLable}
        loading={pageLoading}
        page={{
          items: page.items,
          current: params.current,
          size: params.size,
          total: page.total,
        }}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size: size || 10 })
        }
        columns={Columns((text, t) => {
          if (text === 'topUp') {
            setMembersId(t.id)
            setTopUpModalVisible(true)
            setModalText(0)
          } else if (text == 'refund') {
            setTopUpModalVisible(true)
            setModalText(1)
          } else if (text == 'topUpRecord') {
            setTopUpRecordModalVisible(true)
          } else if (text == 'edit') {
            setAddMembersVisible(true)
            setEditId(t?.id)
          } else if (text == 'detail') {
            history.push({
              pathname: '/member/membersManagement',
              state: {
                membersId: t.id,
                isMenu,
              },
            })
          }
          setMembersId(t.id)
        }, params.size * (params.current - 1))}
        summary={() => (
          <Table.Summary fixed='bottom'>
            <Table.Summary.Row className={styles.total}>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1} align='center'>
                合计
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3}></Table.Summary.Cell>
              <Table.Summary.Cell index={4}></Table.Summary.Cell>
              <Table.Summary.Cell index={5} align='center'>
                {page?.balanceMoneySUM?.toFixed(2)}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={7}></Table.Summary.Cell>
              <Table.Summary.Cell index={8}></Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        onRow={(t) => ({
          onDoubleClick: () => {
            history.push({
              pathname: '/member/membersManagement',
              state: {
                membersId: t.id,
                isMenu,
              },
            })
          },
        })}
      />

      <AddMembersModal // 新增会员
        editId={editId}
        visible={addMembersVisible}
        btnType={addBtnType}
        onCancel={() => setAddMembersVisible(false)}
        onOk={(data) => {
          dispatch(getAddMembers(data))
            .then(unwrapResult)
            .then(() => {
              setAddMembersVisible(false)
              setParams({
                ...params,
              })
            })
            .finally(() => setAddBtnType(!addBtnType))
        }}
      />
      <TopUpModal //充值 or 退款
        visible={topUpModalVisible}
        btnType={addBtnType}
        membersId={membersId}
        modalText={modalText}
        onCancel={() => setTopUpModalVisible(false)}
        onOk={(data) => {
          dispatch(getMembersTopUp(data))
            .then(unwrapResult)
            .then(() => {
              setTopUpModalVisible(false)
              setParams({
                ...params,
              })
              notification.success({
                message: modalText ? '退款成功' : '充值成功',
              })
            })
            .finally(() => setAddBtnType(!addBtnType))
        }}
      />
      <TopUpRecordModal // 充值记录
        visible={topUpRecordModalVisible}
        membersId={membersId}
        onCancel={() => setTopUpRecordModalVisible(false)}
      />
      <BindMembersModal // 会员卡绑定
        visible={bindMembersVisible}
        onCancel={() => {
          setBindMembersVisible(false)
        }}
        onOk={() => {
          setBindMembersVisible(false)
          getTablePage()
        }}
      />
    </Col>
  )
}
